import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

const LAST_NAME_MAX_LENGTH = 30;
const LAST_NAME_MIN_LENGTH = 2;

export const LAST_NAME_SCHEMA_FIELD_NAME = "lastName";

export const getLastNameFormFieldSchema = (label = i18n("LastNameFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .required()
    .min(LAST_NAME_MIN_LENGTH)
    .max(LAST_NAME_MAX_LENGTH)
    .alphaSpace()
    .label(label.toLowerCase());
